import Vue from 'vue';
window.eventBus = new Vue()

import '../MptcfeLib.js'
import '../../less/main_abroad.less'
import "@/utils/iframeDetectForPv"
import 'mptcfe-spm/dist/js/index.js'
import plugin from "../plugin/index.js"
import Cookie from 'js-cookie'
import goSpecialUrl from '../../utils/go-special-url.js'

import PlainDialog from '../../vue_components/plain-dialog.vue';
import BackTop from '../../vue_components/back-top.vue';
import ShareSns from '../../vue_components/share-sns.vue';
import API from '../api';
import CommentFooter  from '../../vue_components/article-main/footer-comment.vue';
import ArtFeed from '../../vue_components/art-feed.vue';
import ShareWechatLayer from '../../vue_components/share-wechat-layer.vue';
import WebClip from '../../vue_components/webclip.vue';
import topHeader from '../../vue_components/common/top-header.vue'
import ArticleOrigin from '../../vue_components/ArticleOrigin.vue'
import ArticleInsertLogic from '../../js/article_insert_logic'; // 功能卡

import Exposure from '../../utils/exposure.js';
import Support from '../../utils/supporter.js';
import SohuStat from '../../statistics/sohu-stat.js';
import PromEvStat from '../../statistics/prom-ev-stat.js';
import AdPluginStat from '../../statistics/ad-plugin-stat.js';
import Util from '../../utils/util';

import Helper from '../../utils/helper.js';
import EventHelper from '../../utils/eventHelper.js';
import sGrade from './article_aa_sgrade.js'

import TransferArticle from '../../vue_components/transfer-article.vue';
import { initSohuTv, resetQQTv, shareWechatFn } from '../plugin/article_common.js'
import { initImgLazyload, initLastImgLazyload } from '../../utils/article-images-lazyload'
import { imgBindClickEvent } from '../../utils/article-images-show'
import questMobile from '../../utils/questMobile'
import { addMomagicAd, middleInsertAd, bottomBannerAd, shareBottomTaboolaAd, shareTopOneMobAd, vidoomyAd } from '@/ad/pages/articleAbroadAd';
import { getUserInfo } from '../request/uisRequest';
import { addBrowseHistory } from '@/utils/browseHistory';
import browseHistoryRemind from '@/utils/browseHistoryRemind';
import NewStatement from '../../vue_components/statement.vue';
import Interaction from '@/vue_components/interaction/index.vue'
import FooterMenu from "@/vue_components/footer-menu.vue";

import { authorAccessArticle,loginAccessArticle } from '@/utils/article-access-limit.js'

var params = Util.parseURL(window.location.href);
if(params._trans_){
    Cookie.set('_trans_', params._trans_, { expires: 7 });
}

window.goSpecialUrl = goSpecialUrl;
const MptcfeUtils = window.MptcfeUtils;
const PerformanceUtil = MptcfeUtils.PerformanceUtil;
const isShowAd = sGrade.isShowAd // 是否展示广告
window.isForbiddenPromotion = !isShowAd

// wap文章页中插广告，文末位置
const initMiddleAd = function(){
    isShowAd && middleInsertAd();
}
// 文末和分享上方Onemob广告请求
const initShareTopOnemobAd = function(){
    isShowAd && shareTopOneMobAd()
}

// 分享下方评论上方Taboola广告请求
const initShareBottomTaboolaAd = function(){
    isShowAd && shareBottomTaboolaAd()
}

// 替换SSP底部通栏广告位请求
const initBottomBannerAd = function(){
    isShowAd && bottomBannerAd()
}

// 页面无固定位置的vidoomy广告
const initVidoomyAd = function(){
    isShowAd && vidoomyAd()
}

// 页面无固定位置的momagic广告
const initMomagicAd = function(){
    console.log("initMomagicAd")
    isShowAd && addMomagicAd()
}

// 图片相关处理
const initPicture = function(){
    //清理图片样式保证在移动端显示正常
    $("#articleContent img[style]").removeAttr("style");
    // 图片懒加载解密
    initImgLazyload()
    // 为图片绑定点击预览事件
    imgBindClickEvent()
}

// 多余标签的处理，由于隐藏的会打码上报曝光，故做此逻辑
const clearTags = function(){
    let $tags = document.querySelectorAll('.article-tags .tag');
    if ($tags && $tags.length > 0) {
        let $tagsP = document.querySelector('.article-tags');
        let firstTagTop = $tags[0].getBoundingClientRect().top;
        for (let i = 0; i < $tags.length; i++) {
            if ($tags[i].getBoundingClientRect().top <= firstTagTop) {
                $tags[i].removeAttribute('data-spm-stop');
            }
        }
    }
}

// 广告插件embed替换iframe
const replaceAdEmbed = function(){
    var adEmbedList = document.querySelectorAll('#articleContent embed[data-plugin]');
    [].slice.call(adEmbedList).forEach(function (adEmbed) {
        var parent = adEmbed.parentNode;
        var sid = adEmbed.getAttribute('data-sid');
        var eid = adEmbed.getAttribute('data-eid');
        // 替换成相对协议
        var reg = /^http:/;
        var url = adEmbed.getAttribute('data-url').replace(reg, '');
        var appid = adEmbed.getAttribute('data-appid');
        var adP = document.createElement('p');
        // 新建iframe替换embed标签
        var adIframe = document.createElement('iframe');
        adIframe.src = url;
        adIframe.setAttribute('data-appid', appid);
        adIframe.setAttribute('data-eid', eid);
        adIframe.setAttribute('data-sid', sid);
        if (parent.nodeName === 'P') {
            // embed的父是p标签时，不包裹
            parent.replaceChild(adIframe, adEmbed);
        } else {
            // 用p标签包裹iframe
            adP.appendChild(adIframe);
            parent.replaceChild(adP, adEmbed);
        }
    })
}

// 顶部导航初始化
const initTopHeader = function(){
    if (document.querySelector('#topHeader')) {
        new Vue({
            el: '#topHeader',
            components: {
                topHeader
            },
        })
    }
}

// 初始化分享组件
const initShare = function(){
    new Vue({
        el: '#shareArea',
        components: {
            ShareSns
        },
        methods: {
        }
    });
}

// 初始化文章来源组件
const initArticleOrigin = function(){
    if(document.querySelector('#articleOrigin')) {
        new Vue({
            el: '#articleOrigin',
            components: {
                ArticleOrigin
            }
        });
    }
}

const renderCommentFooter = function() {
    // 评论组件
    if (document.querySelector("#artCommentArea")) {
        new Vue({
            el: "#artCommentArea",
            components: {
                CommentFooter,
            },
        });
    }
}

//底部标签 && 声明
const renderNewStatement = () => {
    if(!document.querySelector('#newStatement')) return
    new Vue({
        el: '#newStatement',
        components: {
            NewStatement
        }
    })
}

// 互动(评论+视野+讨论)
const renderInteration = () => {
    if(!document.querySelector('#interaction')) return
    new Vue({
        el: '#interaction',
        components: {
            Interaction
        }
    });
}

export const article_abroad = function () {
    // 获取登录状态
    getUserInfo().then((res) => {
        console.log("获取用户信息成功", res);
        if (res?.code == 1 && res?.data) {
            window.userInfo = res?.data;
        }
    })
    .catch((error) => {
        console.log("获取用户信息失败", error);
    })
    .finally(() => {
        //文章页插入功能卡
        if (document.querySelectorAll(".article-main mp-plugin")?.length) {
            ArticleInsertLogic.articleInsert();
        }
        renderCommentFooter()
    });
    // 记录浏览历史
    addBrowseHistory(window.cfgs?.newsId)
    renderNewStatement()
    // 初始化中插广告
    initMiddleAd();

    // 初始化文末和分享上方Onemob
    initShareTopOnemobAd();

    // 初始化分享下方评论上方Taboola
    initShareBottomTaboolaAd();

    // 初始化底部通栏广告
    initBottomBannerAd();

    // 初始化vidoomy广告
    // initVidoomyAd()

    // 初始化momagic广告
    initMomagicAd();

    // 初始化图片处理
    initPicture();

    // 清除多余标签
    clearTags();

    // 广告插件embed替换iframe
    replaceAdEmbed();

    // 广告插件统计初始化
    AdPluginStat.init();

    // 获取文章的次数
    Util.initSSReadState();

    // 曝光类的公共实例对象
    const exposure = new Exposure();

    // 顶部悬浮导航组件
    initTopHeader();

    // 分享组件
    initShare();

    // 文章来源组件
    initArticleOrigin();
    renderInteration()

    // 推荐阅读组件
    new Vue({
        el: "#artRecNews",
        components: {
            ArtFeed,
        },
        data() {
            return {
                config: {
                    articleScene: "abroad", //海外文章页
                },
            };
        },
        methods: {
            addExpose(exposeList) {
                PromEvStat.addExpose(exposeList);
            },
        },
    });

    new Vue({
        el: "#toastDialog",
        components: {
            PlainDialog,
        },
    });

    new Vue({
        el: "#backTop",
        data() {
            return {
                loading: true,
                stat: {},
                exposure: new Exposure(), // 曝光统计
            };
        },
        components: {
            BackTop,
        },
        methods: {
            registerLogin() {
                API.register("show_login", function (params, cal) {
                    let url = `https://m.passport.sohu.com/app/login?appid=116001&r=${encodeURIComponent(
                        params.from
                    )}`;
                    window.location.href = url;
                    if (typeof cal === "function") cal();
                });
            },
            registerBindPhone() {
                API.register("show_bind_phone", function (params, cal) {
                    let url = `https://m.passport.sohu.com/app/quickBindPhone?appid=116001&r=${encodeURIComponent(
                        params.from
                    )}`;
                    window.location.href = url;
                    if (typeof cal === "function") cal();
                });
            },
            showShareDialog() {
                this.$refs.share_dialog.show();
            },
            limitArticleShow() {
                let $lookAll = $("#artLookAll");
                if ($lookAll) {
                    $lookAll.on("click", function () {
                        $("#articleContent .hide").removeClass("hide");
                        $(".lookall-box").hide();
                        initLastImgLazyload();
                        SohuStat.sendActionStat("10120013");
                    });
                }
            },

            addExpose(exposeList) {
                PromEvStat.addExpose(exposeList);
            },
        },
        mounted() {
            let that = this;
            initSohuTv();
            resetQQTv();
            shareWechatFn();
            this.limitArticleShow(); //节流显示文章
            this.registerLogin();
            this.registerBindPhone();
            // 微信中访问正文页时，单独处理分享功能
            if (Support.isWeixin) {
                // 隐藏文章中的分享按钮
                $(".share-sns-wrapper").remove();
                // 顶部导航右上角显示提示“分享到朋友圈”
                var WechatLayer = Vue.extend(ShareWechatLayer);
                var wechatLayer = new WechatLayer({
                    el: document.createElement("div"),
                });
                $(".header__r").remove();
                $(".sub-header").append(wechatLayer.$el);
            }
            // 关注按钮曝光
            exposure.add({
                dom: document.querySelector(".follow"),
                callback: function () {
                    SohuStat.sendActionStat("10002");
                },
            });
            exposure.allExposureCheck();
            exposure.addListener();
            // 推广位曝光统计
            PromEvStat.init();
            // “展开更多”曝光
            if (document.querySelector("#artLookAll")) {
                exposure.add({
                    dom: document.querySelector("#artLookAll"),
                    callback: function () {
                        SohuStat.sendActionStat("10120023");
                    },
                });
            }
            // 网站地图曝光
            exposure.add({
                dom: document.querySelector(".footer-navs-wrapper"),
                callback: function () {
                    SohuStat.sendActionStat("10120021");
                },
            });
        },
    });

    new Vue({
        el: "#webClip",
        components: {
            WebClip,
        },
        mounted() {},
    });

    // 针对百度来源，添加百度官方号ID声明
    if (document.referrer.indexOf("baidu.com") >= 0) {
        Helper.insertScript(
            "//msite.baidu.com/sdk/c.js?appid=1576035302470711",
            true
        );
    }

    // 在轻APP中隐藏所有唤起客户端的元素
    if (Support.isMSOHU) {
        $(
            "#followMedia, #shareAreaInArticle, .c-call-client, .share-btn.icon-share"
        ).hide();
    }
    var isFirstScroll = true;
    //曝光spm
    (function () {
        // 文章页首次滑动曝光
        $(window).on(
            "scroll",
            Util.throttle(function (e) {
                if (isFirstScroll) {
                    // 埋点
                    if (window.sohuSpm) {
                        window.sohuSpm.sendAction({
                            acode: 3403,
                        });
                    }
                    isFirstScroll = false;
                }
            }, 500)
        );

        // 浏览到文章正文末尾
        const articleEnd = document.querySelector(
            "#articleContent section.statement"
        );
        exposure.add({
            dom: articleEnd,
            callback: function () {
                // 埋点-正文末尾
                if (window.sohuSpm) {
                    window.sohuSpm.sendAction({
                        acode: 3405,
                    });
                }
            },
        });
    })();

    //文章末尾用户推广位统计
    (function () {
        const promotionDom = document.querySelector(
            "#articleContent section.promotion a"
        );
        if (!promotionDom) {
            return;
        }
        const uuid = promotionDom.getAttribute("data-uuid");
        const promotionLink = promotionDom.getAttribute("data-link");
        // 自媒体推广
        if (uuid) {
            exposure.add({
                dom: promotionDom,
                callback: function () {
                    SohuStat.sendStatistics("appEv", {
                        appId: 0,
                        mediaId: cfgs.media_id,
                        newsId: cfgs.newsId,
                        lobId: "002",
                    });
                },
            });
        }
        // 通用曝光统计
        exposure.add({
            dom: promotionDom,
            callback: function () {
                SohuStat.sendActionStat(10120450, {
                    contentUrl: encodeURIComponent(promotionLink),
                });
            },
        });

        EventHelper.addHandler(promotionDom, "click", () => {
            if (uuid) {
                SohuStat.sendStatistics("appAction", {
                    appId: 0,
                    actionId: uuid,
                    mediaId: cfgs.media_id,
                    newsId: cfgs.newsId,
                    lobId: "002",
                });
            }

            window.location.href = promotionLink;
        });
    })();

    if(document.querySelector('#transferArticle')) {
        new Vue({
            el: "#transferArticle",
            components: {
                TransferArticle,
            },
            mounted() {},
        });
    }

    // MP功能卡相关逻辑
    (function () {
        let $mpPlugin = $(".article-main mp-plugin");
        let typeMap = {};
        for (let i = 0; i < $mpPlugin.length; i++) {
            try {
                let dataContent = JSON.parse(
                    $mpPlugin[i].getAttribute("data-content")
                );
                let dataType = $mpPlugin[i].getAttribute("data-type");
                new ArticleInsertRec({
                    el: $mpPlugin[i],
                    dataType: dataType,
                    data: dataContent,
                    templateSpm: getSpm(dataType),
                }).init();
            } catch (error) {
                console.log(error);
            }
        }
        //获取各模板spm 码
        function getSpm(type) {
            let articleKey = "r";
            let altasKey = "i";
            let listKey = "c";
            let key = "";
            if (
                type == ArtInsertConfig.articleNoPic ||
                type == ArtInsertConfig.articleOnePic
            ) {
                key = articleKey;
            } else if (type == ArtInsertConfig.atlas) {
                key = altasKey;
            } else if (type == ArtInsertConfig.list) {
                key = listKey;
            }
            typeMap[key] = typeMap[key] ? ++typeMap[key] : 1;
            return `${key}-${typeMap[key]}`;
        }
    })();

    // 浏览历史功能引导提示条
    browseHistoryRemind()

    //添加前端性能上报
    window.onload = () => {
        let opts = {
            mainJs: {
                reg: /\/main-.+\.js/g,
                type: "js",
                name: "jsn",
                duration: "jsd",
            },
            mainCss: {
                reg: /\/main-.+\.css/g,
                type: "css",
                name: "cssn",
                duration: "cssd",
            },
        };
        let performanceReportConfig = PerformanceUtil.performanceReportConfig;
        let performanceReport = PerformanceUtil.performanceReport;

        for (let i in performanceReportConfig) {
            performanceReport(performanceReportConfig[i], i, opts);
        }
        console.log('测试',document.querySelector('#footerMenu'))
        // 底部菜单
        new Vue({
            el: "#footerMenu",
            components: {
                FooterMenu,
            },
        });
        // 为APP增流的上报
        questMobile();
    };
};

window.h5_sohu = {
    article_abroad,
    authorAccessArticle,
    loginAccessArticle,
    plugin
};

// 运行客户端js
window?.eventBus?.$on('runClientJs',article_abroad)